// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__8gebc","hasPadding":"Card_hasPadding__Uh5AW","elevated":"Card_elevated__dcTtj","border":"Card_border__rt05Q"};